import { microsoftAuthConfiguration } from '@/auth/mintAuthConfiguration'
import { BrowserAuthErrorCodes } from '@azure/msal-browser'

const iframeTimeoutCodes = [
  BrowserAuthErrorCodes.monitorWindowTimeout,       // "monitor_window_timeout"
  BrowserAuthErrorCodes.monitorPopupTimeout,        // "monitor_popup_timeout"
  BrowserAuthErrorCodes.nativeHandshakeTimeout,     // "native_handshake_timeout"
  BrowserAuthErrorCodes.iframeClosedPrematurely     // "iframe_closed_prematurely"
]

const isIframeTimeoutError = (code: string) => {
  return iframeTimeoutCodes.includes(code)
}

const isTokenExpirationError = (code: string, message: string): boolean => {
  return message.includes('invalid_grant') || // Common OAuth error for expired/invalid refresh tokens
    message.includes('AADSTS70043') || // Refresh token expired due to conditional access
    message.includes('AADSTS50173') || // Session token expired
    message.includes('AADSTS50076') || // Multi-factor authentication required
    code.includes('invalid_grant') ||
    code.includes('token_expired')
}

const clearCache = async (instance: any) => {
  try {
    await instance.clearCache()
    console.log('MSAL cache cleared successfully')
  } catch (error) {
    console.warn('Could not clear MSAL cache:', error)
  }
  localStorage.clear()
}

const clearCacheAndReload = async (instance: any) => {
  await clearCache(instance)
  window.location.reload()
}

const clearCacheAndReauthenticate = async (instance: any) => {
  await clearCache(instance)

  try {
    const authenticationParameters = await microsoftAuthConfiguration()
    await instance.loginRedirect(authenticationParameters)
  } catch (error) {
    console.error('Error during cache clearing and re-authentication:', error)
    window.location.reload()
  }
}

export {
  clearCacheAndReload,
  clearCacheAndReauthenticate,
  isIframeTimeoutError,
  isTokenExpirationError
}
